<style scoped>
.dialog {
	background-color: white;
	border-radius: 5px;
	padding: 10px;
}
</style>

<template>
	<v-dialog
		v-model="visible"
		max-width="400"
		persistent
	>
		<div class="dialog">
			<div>{{ question}}</div>
			<div>
				<v-text-field
					v-model="answer"
				/>
			</div>
			<div class="text-center">
				<v-btn outlined color="#C4C4C4" @click="cancel()">Cancel</v-btn>
				<v-btn depressed color="#00AAFD" class="ml-2 white--text" @click="ok()">OK</v-btn>
			</div>
		</div>
	</v-dialog>
</template>

<script>
export default {
	data() {
		return {
			visible: false,
			question: "",
			answer: "",
			resolve: null,
			reject: null
		}
	},
	methods: {
		open(question) {
			this.question = question;
			this.visible = true;
			return new Promise((resolve,reject) => {
				this.resolve = resolve;
				this.reject = reject;
			});
		},
		ok() {
			this.visible = false;
			this.resolve(this.answer);
		},
		cancel() {
			this.visible = false;
			this.reject();
		}
	}
}	
</script>
